@if ((messages$ | async).length > 0) {
  <div>
    <rask-message-panel
      [numberOfItemsToDisplay]="5"
      [maxNumOfRows]="3"
      [items]="messages$">
    </rask-message-panel>
  </div>
}